import React, { createContext, useState, useContext, useCallback, useMemo } from 'react';
import VideoPlayerModal from '../components/media/VideoPlayerModal';

const VideoContext = createContext(null);

export const useVideo = () => {
  const context = useContext(VideoContext);
  if (!context) {
    throw new Error('useVideo must be used within a VideoProvider');
  }
  return context;
};

export const VideoProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [videoData, setVideoData] = useState({ url: '', title: '' });

  const playVideo = useCallback((url, title = 'Video') => {
    if (!url) return;
    setVideoData({ url, title });
    setIsOpen(true);
  }, []);

  const closeVideo = useCallback(() => {
    setIsOpen(false);
    // Clear data after transition to prevent flicker
    setTimeout(() => setVideoData({ url: '', title: '' }), 300);
  }, []);

  const value = useMemo(() => ({
    playVideo,
    closeVideo,
    isVideoOpen: isOpen
  }), [playVideo, closeVideo, isOpen]);

  return (
    <VideoContext.Provider value={value}>
      {children}
      <VideoPlayerModal 
        open={isOpen} 
        onClose={closeVideo} 
        videoUrl={videoData.url} 
        title={videoData.title} 
      />
    </VideoContext.Provider>
  );
};

export default VideoContext;